import { BaseService } from '../../http-layer/service/base.service'

export interface RegisterPushTokenPayload {
  pushToken: string
  sessionId: string
  deviceType: string
  appType: string
}

export interface RegisterPushTokenResponse {
  success: boolean
}

export class PushNotificationsService extends BaseService {
  constructor() {
    super({
      baseURL: 'CLIENTPORTAL_SERVER_URL',
      serviceName: 'PushNotificationsService',
    })
  }

  async registerPushToken(payload: RegisterPushTokenPayload, locationId: string): Promise<RegisterPushTokenResponse> {
    const { data } = await this.post<RegisterPushTokenResponse>(`/v2/${locationId}/auth/register-push-token`, payload)
    return data
  }
}
